import { render, staticRenderFns } from "./ModalCartaoDesassociado.vue?vue&type=template&id=42862832&"
import script from "./ModalCartaoDesassociado.vue?vue&type=script&lang=js&"
export * from "./ModalCartaoDesassociado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports